import { project2BaseUrl } from './remoteClient';

export async function competenciesRequest(token) {
    return await project2BaseUrl.get('/consortium/getCompetencies', {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}